import { mdiCheck, mdiClose } from '@mdi/js';
import type { MappedCustomDataServiceObjectField, SelectValue } from 'common/models';
import Icon from 'components/Icon/Icon';
import dayjs from 'dayjs';
import { toLocaleString } from 'helpers/mathHelpers';
import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';

interface OwnProps {
  fieldData: MappedCustomDataServiceObjectField;
  serviceObjectId: string;
}

const ServiceObjectTableColumn = (props: OwnProps) => {
  const { fieldData, serviceObjectId } = props;

  const { i18n } = useCustomTranslation();

  const fieldValue = fieldData.values.find((x) => x.serviceObjectId === serviceObjectId)?.value;

  switch (fieldData.formField.type) {
    case 'DateTime':
      return (
        <span>
          {fieldValue.value &&
            dayjs
              .utc(fieldValue.value)
              .locale(i18n.language)
              .format(fieldData.format || 'LLL')}
        </span>
      );
    case 'Date':
      return (
        <span>
          {fieldValue.value &&
            dayjs
              .utc(fieldValue.value)
              .locale(i18n.language)
              .format(fieldData.format || 'LL')}
        </span>
      );
    case 'Time':
      return (
        <span>
          {fieldValue.value &&
            dayjs
              .utc(fieldValue.value)
              .locale(i18n.language)
              .format(fieldData.format || 'LT')}
        </span>
      );
    case 'Boolean':
      return (
        <span>
          {fieldValue.value ? (
            <Icon path={mdiCheck} className="text-success" />
          ) : (
            <Icon path={mdiClose} className="text-danger" />
          )}
        </span>
      );
    case 'Number': {
      const value =
        fieldValue.value || fieldValue.value === 0
          ? toLocaleString(fieldValue.value * (fieldData?.multiplier || 1))
          : '';

      return (
        <span>{fieldData.formField.unit ? `${value} ${fieldData.formField.unit}` : value}</span>
      );
    }

    case 'Select':
      if (fieldData.formField.isMultiSelect) {
        return (
          <span>{fieldValue.value.map((value: SelectValue) => value.stringValue).join(', ')}</span>
        );
      }
      return <span>{fieldValue.stringValue}</span>;
    // Checklist is unsupported field
    case 'CheckList':
      return <span />;
    case 'GeoCoordinate':
      return fieldValue.value ? (
        <span>{`${fieldValue.value.latitude}, ${fieldValue.value.longitude}`}</span>
      ) : (
        <span />
      );
    default:
      return <span>{fieldValue.value}</span>;
  }
};

export default ServiceObjectTableColumn;
